import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

interface WorkoutHeaderProps {
  onBack: () => void;
}

export const WorkoutHeader = ({ onBack }: WorkoutHeaderProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="absolute top-4 left-4 z-10 bg-white/10 dark:bg-white/5 backdrop-blur-md border border-white/20 hover:bg-white/20 dark:hover:bg-white/10 transition-all duration-300 rounded-xl shadow-lg"
      onClick={onBack}
    >
      <ChevronLeft className="h-6 w-6" />
    </Button>
  );
};
